/**
 * Emplacements publicitaires : STUB UNIQUEMENT. Aucun SDK n'est charge, aucune
 * requete n'est emise, rien n'est mesure.
 *
 * L'interface existe pour que les points d'appel soient decides et cables
 * maintenant, pendant qu'on maitrise le flux, plutot que d'etre greffes plus
 * tard au milieu du jeu. Brancher un vrai reseau (H5 Games Ads) reviendra a
 * fournir une autre implementation de AdAdapter, sans toucher aux ecrans.
 *
 * Regle non negociable : jamais pendant DRAWING, GUESSING ou REVEAL. Les trois
 * points ci-dessous sont tous des temps morts.
 */
export type AdPlacement = 'preroll' | 'interstitial';

export interface AdAdapter {
  /** Appele une seule fois, apres consentement. */
  init(): Promise<void>;
  /** Avant la premiere partie d'une session. */
  showPreroll(): Promise<void>;
  /** Entre deux manches, ou avant un REJOUER. */
  showInterstitial(): Promise<void>;
}

/**
 * Implementation par defaut : ne fait rien et resout immediatement, pour que le
 * jeu ne depende jamais de la publicite pour avancer.
 */
export class NoopAdAdapter implements AdAdapter {
  private initialized = false;

  async init(): Promise<void> {
    if (this.initialized) return;
    this.initialized = true;
    console.info('[ads] stub initialise (aucun SDK charge)');
  }

  async showPreroll(): Promise<void> {
    this.log('preroll');
  }

  async showInterstitial(): Promise<void> {
    this.log('interstitial');
  }

  private log(placement: AdPlacement): void {
    if (!this.initialized) {
      console.info(`[ads] ${placement} ignore : pas de consentement`);
      return;
    }
    console.info(`[ads] ${placement} : emplacement atteint (stub, rien affiche)`);
  }
}

let adapter: AdAdapter = new NoopAdAdapter();
let initialized = false;

export function setAdAdapter(next: AdAdapter): void {
  adapter = next;
  initialized = false;
}

/** N'initialise l'adapter que si le joueur a consenti. */
export async function initAds(consented: boolean): Promise<void> {
  if (!consented || initialized) return;
  initialized = true;
  await adapter.init();
}

export async function showPreroll(): Promise<void> {
  await adapter.showPreroll();
}

export async function showInterstitial(): Promise<void> {
  await adapter.showInterstitial();
}

/**
 * Un interstitiel entre manches n'a lieu que sur les parties longues, et
 * seulement au passage de la manche 2 a la 3 : une coupure, pas plus.
 */
export const INTERSTITIAL_AFTER_ROUND = 2;
export const INTERSTITIAL_MIN_ROUNDS = 5;

export function shouldShowRoundInterstitial(round: number, totalRounds: number): boolean {
  return totalRounds >= INTERSTITIAL_MIN_ROUNDS && round === INTERSTITIAL_AFTER_ROUND;
}
